import { Association } from "../../lib/association-store";

export class AppDistributionGroup extends Association {}
